import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    right: {
        paddingLeft: "1rem",
    },
    start: {
        
    },
    element: {
        marginBottom: "1rem",
        marginTop: "1rem",

    },
    container: {
        marginLeft: 'auto',
        textAlign: 'center',
        marginRight: 'auto',
        marginTop: "2rem",
        width: "400px",
        maxWidth: "100%"
    }
  }));

  const marks = [
    {
      value: 0,
      label: 'Platt',
    },
    // {
    //   value: 15,
    //   label: 'Lite lutning',
    // },
    {
      value: 30,
      label: 'Standard',
    },

    {
      value: 60,
      label: 'Spetsigt'
    }

  ];

const Slope = ({active, next, info, state, change}) => {
    const [value, setValue] = React.useState(info.front.geometry.roofAngel);
    React.useEffect(() => {
      change({...state, geometry: {...state.geometry, roofAngel: value}})
    }, [value])
    const classes = useStyles();
    return <Container><Grid container spacing={3} className={classes.container}>
    <Grid item xs={12}>
            <Typography variant="h3" className={classes.element}>Hur mycket lutar ditt tak?</Typography>
            <Typography variant="subtitle1"  className={classes.element}>Vi använder taklutningen för att uppskatta produktionen på anläggningen.</Typography>
    </Grid>

    <Grid item xs={12}>
    <Slider
        defaultValue={30}
        aria-labelledby="discrete-slider-always"
        step={5}
        max={60}
        min={0}
        marks={marks}
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        valueLabelDisplay="on"
        />
        <Button color="primary" onClick={event => next()} fullWidth size="large" variant="outlined" className={classes.element}>Fortsätt</Button>
    </Grid>

</Grid></Container>


};

export default Slope;